import { createContext, useContext, type ReactNode } from 'react';
import type { AdminSubscriptionAccessStatus } from '@/api/clubs-booking';

export type AdminSubscriptionRouteSnapshot = {
  status: AdminSubscriptionAccessStatus;
  receivedAtMs: number;
};

const AdminSubscriptionRouteContext = createContext<AdminSubscriptionRouteSnapshot | null>(null);

export function AdminSubscriptionRouteProvider({
  snapshot,
  children,
}: {
  snapshot: AdminSubscriptionRouteSnapshot | null;
  children: ReactNode;
}) {
  return (
    <AdminSubscriptionRouteContext.Provider value={snapshot}>{children}</AdminSubscriptionRouteContext.Provider>
  );
}

export function useAdminSubscriptionRouteSnapshot(): AdminSubscriptionRouteSnapshot | null {
  return useContext(AdminSubscriptionRouteContext);
}
